import React, { Component } from "react";
import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";
import "react-images-uploader/styles.css";
import Video from "../trainer/unit/Video";
import Youtube from "../trainer/unit/Youtube";
import Audio from "../trainer/unit/Audio";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
import DataTable from "react-data-table-component";
import { Line, Circle } from "rc-progress";

export default class TopicListLearner extends Component {
  state = {
    courseName: "",
    courseDisc: "",
    courseImage: "",
    categoryId: "",
    categoryName: "A sample Category",
    courseStartDate: "",
    courseStatus: false,
    selectedUnitType: 0,
    srNo: 1,
    selectedOption: 1,
    unitTypes: [
      { id: 1, unitName: "Video", unitIcon: <i class="fas fa-video"></i> },
      { id: 2, unitName: "Youtube", unitIcon: <i class="fab fa-youtube"></i> },
      { id: 3, unitName: "Audio", unitIcon: <i class="fas fa-microphone"></i> },
      { id: 4, unitName: "Quiz", unitIcon: <i class="fas fa-question"></i> },
      { id: 5, unitName: "Live Class", unitIcon: <i class="fas fa-wifi"></i> },
      { id: 6, unitName: "Course", unitIcon: <i class="fas fa-bars"></i> },
    ],
    trainerOptions: [
      //   {
      //     id: 1,
      //     name: "CONTENT",
      //     subname: "0 inactive",
      //     icons: <i class="fas fa-th"></i>,
      //   },
      {
        id: 2,
        name: "USERS & PROGRESS",
        subname: "1 instructor · 0 learners",
        icons: <i class="fas fa-user"></i>,
      },
      //   {
      //     id: 3,
      //     name: "FILES",
      //     subname: "0 files",
      //     icons: <i class="fas fa-folder-open"></i>,
      //   },
      {
        id: 4,
        name: "RULES & PATH ",
        subname: "Sequential rule set",
        icons: <i class="fas fa-chart-line"></i>,
      },
      {
        id: 5,
        name: "REPORTS",
        subname: "No Reports",
        icons: <i class="fas fa-chart-pie"></i>,
      },
    ],
    topics: [],
    columns: [
      // {
      //   name: "#",
      //   selector: "year",
      //   sortable: true,
      //   left: true,
      //   cell: (row) => (
      //     <div className="d-flex">
      //       <p>{this.state.srNo++}</p>
      //     </div>
      //   ),
      // },
      {
        name: "Image",
        selector: "image",
        sortable: true,
        cell: (row) => (
          <div>
            {row.image && row.image !== "undefined" ? (
              <img
                src={row.image}
                alt="data"
                width="40"
                height="40"
                onError={(e) => {
                  e.target.src =
                    "./images/homepage/placeholder-img.jpg";
                }}
              />
            ) : (
                <img
                  src="./images/homepage/placeholder-img.jpg"
                  alt="data"
                  width="40"
                  height="40"
                />
              )}
          </div>
        ),
      },
      {
        name: "Topic Name",
        selector: "name",
        sortable: true,
        left: true,
      },
      {
        name: "Content Type",
        selector: "contentType",
        sortable: true,
      },
      {
        name: "Topic Progress",
        selector: "topicStatus",
        sortable: true,
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: (row) => (
          <div className="d-flex">
            <Link
              to={`/learner/view-topic/${this.props.match.params.courseID}&${row.id}`}
            >
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-share text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };
  componentDidMount() {
    this.getCourses();
    this.getTopicsList();
    this.getCategory();
  }
  enableCourseName = () => {
    this.setState({ enableCourseName: true });
  };
  enableCourseDisc = () => {
    this.setState({ enableCourseDisc: true });
  };
  closeNameEditing = () => {
    this.setState({ enableCourseName: false });
  };
  closeDiscEditing = () => {
    this.setState({ enableCourseDisc: false });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSelectUnit = (id) => {
    this.setState({ selectedUnitType: id });
  };
  onSelectedOptions = (id) => {
    this.setState({ selectedOption: id });
  };
  getCourses = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    console.log(localStorage.getItem("lms_site_id"));
    console.log(this.props.match.params.courseID);

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.courseID);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        console.table("tablename", data);
        this.setState({
          courseName: data.name,
          courseDisc: data.description,
          courseImage: data.image,
          courseStartDate: JSON.parse(data.content).startDate,
          categoryId: data.category_id,
          courseStatus: data.courseStatus,
          // topics: data.topics,
          certificate_image_id: data.certificate_image_id,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  getTopicsList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    console.log(localStorage.getItem("lms_site_id"));
    console.log(this.props.match.params.courseID);

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.courseID);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        this.setState({
          topics: data
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  getCategory = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("categoryId", this.state.categoryId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        console.table("tablename", data);
        this.setState({
          categoryName: data.name,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  getDate = (date) => {
    var date = new Date(date);
    return `${date.getUTCDate()}/${
      date.getUTCMonth() + 1
      }/${date.getUTCFullYear()}`;
  };
  render() {
    console.log("Objective Killed", this.state.topics);
    return (
      <div className="py-3">
        <div className="container create-course border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/learner/course-list">Home</Link> /{" "}
                  <Link to="/learner/course-list">Courses</Link> /{" "}
                  <b>{this.state.courseName}</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {this.state.courseStatus === "complete" || this.state.courseStatus === "Complete" || this.state.courseStatus === "COMPLETE"
                  ? <span class="topic-ribbon1">
                    <span>Completed</span>
                  </span>
                  :
                  null}
              </div>
            </div>
          </div>

          <div className="row m-0">
            <div className="col-md-8 left-section border-right">
              <div className="row">
                <div>
                  {this.state.courseImage ? (
                    <img
                      alt="coures"
                      className="m-4"
                      width="150"
                      height="100"
                      src={this.state.courseImage}
                    />
                  ) : (
                      <img
                        alt="coures"
                        className="m-4"
                        width="150"
                        height="100"
                        src="https://akm-img-a-in.tosshub.com/indiatoday/images/story/201811/online-3412473_1920_1.jpeg?tz.RfsTe_UTLHiDqxmpG7PY_nTIBjwF7"
                      />
                    )}
                </div>
                <div className="align-content-center mt-3 d-flex align-items-center">
                  <div>
                    <h4 className="pl-3">{this.state.courseName}</h4>
                    <p className="pl-3">{this.state.courseDisc}</p>
                    <p className="pl-3 m-0">
                      <b> Category :</b> {this.state.categoryName}
                    </p>
                    <p className="pl-3 m-0">
                      <b>Created On : </b>
                      {this.getDate(this.state.courseStartDate)}
                    </p>
                    {this.state.courseStatus === "Complete" && this.state.certificate_image_id !== null ? (
                      <p className="pl-3 m-0">
                        <Link
                          to={`/certificates/${this.props.match.params.courseID}`}
                          className="btn btn-primary"
                        >
                          See Certificate
                        </Link>
                      </p>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>{" "}
              {/* <b>Progress</b>
              <Line
                percent="75"
                className="mt-1 mb-2"
                strokeWidth="1.5"
                strokeColor="#42cabb"
              /> */}
              <DataTable
                noHeader={true}
                columns={this.state.columns}
                data={this.state.topics}
                theme="solarized"
                pagination={true}
                noDataComponent={
                  <div className="m-3">No Topics Available to learn</div>
                }
              />
            </div>
            <div className="col-md-4 right-section pl-0">
              {this.state.trainerOptions.map((option) => (
                <div
                  onClick={this.onSelectedOptions.bind(this, option.id)}
                  className={`card card-selector shadow-sm p-2 m-2 ${
                    option.id == this.state.selectedOption ? "selected" : ""
                    }`}
                >
                  <div className="row">
                    <div className="col-2">
                      <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                        {option.icons}
                      </div>
                    </div>
                    <div className="col-10">
                      <div className="text d-flex flex-column">
                        <h5 className="m-0 btn-link">{option.name}</h5>
                        <p className="m-0">{option.subname}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
